/**
 * Helpers for the PT4xx errors our SECURITY DEFINER RPCs raise
 * (`RAISE ... USING ERRCODE = 'PT401', DETAIL = 'tenant'`).
 *
 * Check these BEFORE handing an error to translateSystemError(): that helper
 * treats every coded error as a system error and replaces it with a generic
 * message, so the code and detail are lost afterwards.
 */

interface RpcErrorLike {
  code?: unknown;
  details?: unknown;
}

const asRpcError = (error: unknown): RpcErrorLike | undefined =>
  typeof error === 'object' && error !== null ? (error as RpcErrorLike) : undefined;

/** True when `error` carries SQLSTATE `code` (and, if given, DETAIL `detail`). */
export function isRpcError(error: unknown, code: string, detail?: string): boolean {
  const rpcError = asRpcError(error);
  if (rpcError?.code !== code) return false;
  return detail === undefined || rpcError.details === detail;
}

export const SESSION_ACCESS_MESSAGE =
  'Your session no longer has access to this dealership. Please sign in again.';

/** The token names a tenant other than its own (recall RPCs, dealer RPCs). */
export const isTenantAccessError = (error: unknown) => isRpcError(error, 'PT401', 'tenant');

export class TenantAccessError extends Error {
  constructor() {
    super(SESSION_ACCESS_MESSAGE);
    this.name = 'TenantAccessError';
  }
}
